<template>
    <div class="blurb">
        <div class="headline">{{ $t('headline.title4') }}</div>
        <div class="main">
            <div class="imgBox">
                <img :src="`https://4d-ai.chat/img/${$t('img.company')}.jpg`">
            </div>
            <div class="content">
                <p>{{ $t('introduction.p1') }}</p>
                <p> {{ $t('introduction.p2') }}</p>
                <p>{{ $t('introduction.p3') }}</p>
                <p>{{ $t('introduction.p4') }}</p>
                <div class="numList">
                    <div class="numbox">
                        <div class="number">64%</div>
                        <div class="type">{{ $t('introduction.p5') }}</div>
                    </div>
                    <div class="numbox">
                        <div class="number">4+</div>
                        <div class="type">{{ $t('introduction.p6') }}</div>
                    </div>
                    <div class="numbox">
                        <div class="number">200+</div>
                        <div class="type">{{ $t('introduction.p7') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    mounted() {

    },
    methods: {}
}
</script>
<style scoped>
@media (max-width: 768px) {
    p {
        font-size: 12px !important;
    }

    .blurb {
        padding: 50px 10px 0px !important;
    }

    .main {
        flex-direction: column !important;
    }

    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .imgBox {
        width: 100% !important;
        height: 100% !important;
        overflow: hidden !important;
        border-radius: 15px !important;
    }

    img {
        width: 100% !important;
        border-radius: 15px !important;
    }

    .content {
        width: 100% !important;
        gap: 10px !important;
    }

    .number {
        font-size: 30px !important;
    }

    .type {
        font-size: 14px !important;
    }

    .numList {
        padding-top: 0 !important;
        gap: 30px !important;
    }
}
</style>
<style scoped lang="less">
.blurb {
    background-color: #fff;
    padding: 80px 212px;
    box-sizing: border-box;

    .main {
        display: flex;
        align-items: center;

        .imgBox {
            width: 50%;
            border-radius: 15px;
            overflow: hidden;
            height: 532px;

            img:hover {
                transform: scale(1.2);
            }

            img {
                width: 100%;
                height: 100%;
                transition: all 0.6s;
            }
        }

        .content {
            width: 50%;
            padding-left: 48px;
            height: 100%;
            box-sizing: border-box;
            font-size: 20px;
            color: #4c5563;
            display: flex;
            flex-direction: column;
            gap: 24px;

            p {
                margin: 0;
                padding: 0;
            }

            .numList {
                padding-top: 24px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                gap: 32px;

                .numbox {
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    .number {
                        font-size: 36px;
                        color: #243c8a;
                        font-weight: 600;
                    }

                    .type {
                        font-size: 16px;
                        color: #4c5563;
                    }
                }
            }
        }
    }
}

.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 64px;
}
</style>